const actions = {
  SET_DESTINATION_FROM: "SET_DESTINATION_FROM",
  SET_DESTINATION_TO: "SET_DESTINATION_TO",
  SET_DESTINATION_DATE: "SET_DESTINATION_DATE",
  SET_DESTINATION_DATE_TWO_WAY: "SET_DESTINATION_DATE_TWO_WAY",
  SET_SHOW_TWO_WAY_DATE_INPUT: "SET_SHOW_TWO_WAY_DATE_INPUT",

  setDestinationFrom: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_DESTINATION_FROM,
        value,
      });
    };
  },

  setDestinationTo: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_DESTINATION_TO,
        value,
      });
    };
  },
  setDestinationDate: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_DESTINATION_DATE,
        value,
      });
    };
  },

  setDestinationDateTwoWay: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_DESTINATION_DATE_TWO_WAY,
        value,
      });
    };
  },

  setShowTwoWayDateInput: (value) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_SHOW_TWO_WAY_DATE_INPUT,
        value,
      });
    };
  },
};
export default actions;
